import {useState, useEffect} from 'react';
import {Box, IconButton, Typography} from '@mui/material';

import {useDispatch, useSelector} from 'react-redux';

import CloseIcon from '@mui/icons-material/Close';
import {t} from 'i18next';
import {RootState} from '../../../redux/store';
import AurBanner from '../../common/aur-banner/AurBanner';
import {setTaggingStatus} from '../../../redux/slices/ecaDocListSlice';

const BulkTaggingStatusBanner = () => {
  const taggingStatus = useSelector(
    (state: RootState) => state.ecaDocList.taggingStatus
  );
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();

  // Show banner whenever taggingStatus updates
  useEffect(() => {
    if (taggingStatus) {
      setOpen(true);
    }
  }, [taggingStatus]);

  // Function to close banner and reset Redux store
  const handleClose = () => {
    setOpen(false);
    dispatch(setTaggingStatus(null));
  };

  // Function to render the dismiss button
  const renderAction = () => (
    <IconButton
      className="typo-text buttonSmall_size"
      name="dismiss"
      aria-label="close"
      onClick={handleClose}
    >
      <CloseIcon fontSize="small" sx={{color: '#F2F4F7'}} />
      <Typography className="typo-text label2_size dismiss">
        {t('buttons.dismiss')}
      </Typography>
    </IconButton>
  );

  if (!open || !taggingStatus) return null; // Hide if closed or no status
  return (
    <Box className="bulk-tagging-status-banner">
      <AurBanner
        errorText={t(
          `ecaDocList.bulkTagging.apply.${taggingStatus === 'Completed' ? 'success' : 'failed'}`
        )}
        errorType={taggingStatus === 'Completed' ? 'success' : 'error'}
        showIcon
        hasFullWidth
        renderAction={renderAction}
      />
    </Box>
  );
};

export default BulkTaggingStatusBanner;
